import AuthScreen from './AuthScreen'

export default AuthScreen
